export class IPaginationResult<T> {
  size: number = 0;
  data: T[] = [];
}